function services(state = [], action) {
  if (action.type === 'ADD_SERVICE') {
    return [...state, action.service]
  }
  return state;
}

export default services;


// WEBPACK FOOTER //
// ./src/reducers/services.js